//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-project-modal',
    props: {
        onSelected: Function
    },
    data() {
        return {
            searchInput: {},
            loading: false,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '城市名称',
                    align: 'center',
                    key: 'cityName',
                    width: 99,
                },
                {
                    title: '项目名称',
                    align: 'center',
                    key: 'name',
                },

                {
                    title: '项目地址',
                    align: 'center',
                    key: 'address'
                }
                // {
                //     title: '操作',
                //     render: (h, params) => {
                //         const row = params.row;
                //         const actions = [];
                //
                //         var del = h('Button', {
                //             props: {
                //                 type: 'error',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.delProject(params.row);
                //                 }
                //             }
                //         }, '删除');
                //
                //         actions.push(h('Button', {
                //             props: {
                //                 type: 'primary',
                //                 size: 'small'
                //             },
                //             style: {
                //                 marginRight: '5px'
                //             },
                //             on: {
                //                 click: () => {
                //                     vm.editProject(params.row);
                //                 }
                //             }
                //         }, '编辑'));
                //         actions.push(del);
                //         return h('div', actions);
                //     }
                // }
            ]
        };
    },
    computed: {
        currentPage() {
            return this.$store.state.project.currentPage;
        },
        totalCount() {
            return this.$store.state.project.totalCount;
        },
        pageSize() {
            return this.$store.state.project.pageSize;
        },
        list() {
            return this.$store.state.project.list;
        }

    },
    methods: {
        pageChange(page) {
            this.$store.commit('project/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('project/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'project/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        }
    },
    created() {
        this.getPage();
    }

};
